import React from "react";
import newcircle from "../Assets/Untitled design-optimized.webp";
import { Link } from "react-router-dom";

function CircleImg() {
  return (
    <>
      <div className="new-circle-div">
        <div className="new-circle-div-left">
          <h3>Follow Cine Celebrate on Instagram!</h3>
          <h2>
            Where Every Frame
            <br /> Tells a Story
          </h2>

          <p>
            {/* Follow us on Instagram for epic movie moments, exclusive premieres,
            star-studded updates, and a celebration of cinema like never before.
            The spotlight is waiting for you! */}
            Where Memories Light Up the Screen
            <br />
            <br />
            Discover jaw-dropping celebration reels, cinematic party makeovers,
            luxury theater setups, proposal surprises, bachelorette themes, and
            cozy couple screenings—only on our Instagram! 💫
            <br />
            <br />
            Follow @CineCelebrate for trending content, viral party ideas, and
            the most
            <br />
            <br />
            Instagrammable private theater in town. Your reel-worthy
            moment starts here!
          </p>
        </div>

        <div className="new-circle-div-right">
          <Link
            style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
            to="https://www.instagram.com/cinecelebrate_in"
          >
            <img
              src={newcircle}
              alt="Cine Celebrate Instagram preview"
              loading="lazy"
              decoding="async"
            />
          </Link>
        </div>
      </div>
    </>
  );
}

export default CircleImg;
